import React from "react";
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Stack,
  Typography,
  Chip,
  LinearProgress,
  IconButton,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useDispatch, useSelector } from "react-redux";
import { fetchMyPromotions } from "../../../store/Slices/promotionSlice";

export default function MySubmissions() {
  const dispatch = useDispatch();
  const { myItems, loadingMine } = useSelector((s) => s.promotion);

  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: 6,
        bgcolor: "background.paper",
        display: "flex",
        flexDirection: "column",
        height: 550, // 👈 يمكنك تغيير الطول هنا
      }}
    >
      <CardHeader
        title="My Submissions"
        action={
          <IconButton onClick={() => dispatch(fetchMyPromotions())}>
            <RefreshIcon />
          </IconButton>
        }
        sx={{ pb: 0 }}
      />

      {/* محتوى البطاقة مع تمرير عمودي */}
      <CardContent
        sx={{
          flex: 1,
          overflowY: "auto",
          pr: 1, // لتجنب تداخل شريط التمرير مع النص
        }}
      >
        {loadingMine && <LinearProgress sx={{ mb: 1 }} />}
        <Stack spacing={1}>
          {myItems.map((row) => (
            <Box
              key={row._id}
              sx={{
                p: 1.5,
                borderRadius: 2,
                bgcolor: "action.hover",
                display: "grid",
                gridTemplateColumns: "1fr auto",
                gap: 2,
              }}
            >
              <Box>
                <Typography variant="subtitle2" color="text.primary">
                  {row.type} / {row.platform}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ wordBreak: "break-all" }}
                >
                  {row.video_url}
                </Typography>
                <Chip
                  size="small"
                  label={row.status?.toUpperCase()}
                  color={
                    row.status === "approved"
                      ? "success"
                      : row.status === "rejected"
                      ? "error"
                      : "warning"
                  }
                  variant="outlined"
                  sx={{ mt: 0.5 }}
                />
              </Box>
              <Box textAlign="right">
                <Typography variant="body2" color="text.primary">
                  Reward: <b>{row.reward_usdt || 0} USDT</b>
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Created: {new Date(row.created_at).toLocaleString()}
                </Typography>
              </Box>
            </Box>
          ))}

          {!myItems.length && !loadingMine && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ textAlign: "center", mt: 2 }}
            >
              No submissions yet.
            </Typography>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
